import { klaviyoAnalytics } from "../klaviyo";

export function identify(data) {
  klaviyoAnalytics("identify", null, {
    $email: data.email,
  });
}
